import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { SimNaoPipe } from '../../../pipes/sim-nao-pipe';
import { TipoAgendamentoPipe } from '../../../pipes/tipo-agendamento-pipe';
import { ProcedimentoConsulta } from '../procedimento-consulta';
import { ProcedimentoConsultaService } from '../procedimento-consulta.service';

@Component({
  selector: 'app-procedimento-consulta-list',
  templateUrl: './procedimento-consulta-list.component.html',
  styleUrls: ['./procedimento-consulta-list.component.css']
})
export class ProcedimentoConsultaListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['nome', 'especialidade', 'tipoAgendamentoFormatado', 'valor', 'disponivelFormatado', 'details'];

  constructor(private procedimentoConsultaService: ProcedimentoConsultaService, router: Router,
    dialog: MatDialog, private tipoAgendamentoPipe: TipoAgendamentoPipe, private simNaoPipe: SimNaoPipe) {

    super(router, dialog);
  }

  ngOnInit() {
    this.reloadData();

    super.ngOnInit();
  }

  reloadData() {
    this.procedimentoConsultaService.listar()
      .subscribe(data => {
        // console.log(data)
        this.data = data as ProcedimentoConsulta[];

        this.data = this.configurarformatacoes(this.data);

        this.configurarDataSource();
      }, error => {
        console.log(error);
      });
  }

  configurarformatacoes(data: ProcedimentoConsulta[]) {
    data.forEach(
      (val, index) => {
        data[index].tipoAgendamentoFormatado = this.tipoAgendamentoPipe.transform(data[index].tipoAgendamento)
        data[index].disponivelFormatado = this.simNaoPipe.transform(data[index].disponivel)
      });

    /*
    data.forEach(
      (val, index) => {
        console.log(data[index].tipoAgendamentoFormatado)
        console.log(data[index].disponivelFormatado)
      });
    */

    return data;
  }

  confirmDelete(id: number) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: number) {
    this.procedimentoConsultaService.remover(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData();
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterProcedimentoConsulta']);
  }

  details(id: number) {
    this.router.navigate(['manterProcedimentoConsulta'], {
      state: {
        id: id,
        isUpdate: 'N',
        procedimentoConsulta: this.getProcedimentoConsultaSelecionado(id)
      }
    });
  }

  update(id: number) {
    this.router.navigate(['manterProcedimentoConsulta'], {
      state: {
        id: id,
        isUpdate: 'S',
        procedimentoConsulta: this.getProcedimentoConsultaSelecionado(id)
      }
    });
  }

  getProcedimentoConsultaSelecionado(idProcedimentoSelecionado: number): ProcedimentoConsulta | null {

    if (this.data) {
      let currentProcedimentoConsulta: any = this.data.find((obj: { id: number; }) => obj.id == idProcedimentoSelecionado);

      return currentProcedimentoConsulta as ProcedimentoConsulta;
    }

    return null;
  }
}
